import { Box } from '@chakra-ui/react'
import { SidebarItem } from 'components/LeftSidebar/components/SideBarContent/constants'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import { getValidArray } from 'utils/common'
import { isSidebarItemActive, useActiveSidebarPath } from '../../sidebar-active-path'
import MenuItemLink from '../MenuItemLink'

interface IMenuItemProps {
  item: SidebarItem
  isActive?: boolean
  isCondensed?: boolean
}

const MenuItem = ({ item, isActive, isCondensed }: IMenuItemProps) => {
  const isExpandable = !!item?.children?.length
  const [isExpanded, setIsExpanded] = useState(false)
  const activePath = useActiveSidebarPath()

  function rePositionBox(): void {
    const parentY = document.getElementById('highlight-box-expanded')?.getBoundingClientRect().y ?? 0
    const target = document.getElementById('sub-item-wrapper')
    target?.style?.setProperty('bottom', `calc(100vh - ${parentY + 56}px)`)
  }

  useEffect(() => {
    rePositionBox()
    if (isExpandable && isExpanded) {
      document.addEventListener('resize', rePositionBox)
    }

    return () => {
      document.removeEventListener('resize', rePositionBox)
    }
  }, [isExpandable, isExpanded])

  return (
    <Box as="li" position="relative" listStyleType="none">
      <Box id={isExpanded && isExpandable ? 'highlight-box-expanded' : undefined}>
        <MenuItemLink item={item} isActive={isActive} isExpanded={isExpanded} isCondensed={isCondensed} />
      </Box>

      {isExpandable && !isCondensed && (
        <Box
          as="button"
          aria-label={`toggle-${item.name}`}
          onClick={() => setIsExpanded(!isExpanded)}
          width="100%"
          height="40px"
          opacity={0}
          position="absolute"
          top={0}
        />
      )}

      {isExpandable && isExpanded && !isCondensed && (
        <Box id="sub-item-wrapper">
          {getValidArray(item?.children).map((child, index) => {
            const isChildActive = isSidebarItemActive(child, activePath)
            return (
              <Box
                key={child.path + '-' + index}
                pl="16px"
                _hover={{ bg: isChildActive ? undefined : 'whiteAlpha.50' }}
              >
                <MenuItemLink item={child} isActive={isChildActive} isExpanded={isExpanded} />
              </Box>
            )
          })}
        </Box>
      )}
    </Box>
  )
}

export default observer(MenuItem)
